import Vue from 'vue';
import Vuetify,
{
  VSnackbar,
  VBtn,
  VTab,
  VIcon,
  VItemGroup,
  VSpacer,
  VSlider,
} from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';
import en from 'vuetify/es5/locale/en';
import VuetifyToast from 'vuetify-toast-snackbar';
import i18n from '@/i18n';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VTab,
    VIcon,
    VItemGroup,
    VSpacer,
    VSlider,
  },
});

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0A82D9',
        success: '#1FC57F',
      },
    },
  },
  lang: {
    locales: { ru, en },
    current: i18n.locale,
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});

export default vuetify;

Vue.use(VuetifyToast, {
  $vuetify: vuetify.framework,
  y: 'top',
  timeout: 4000,
});
